
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'productupdates-ui',
  currentProjectVersion: 'static-1.7414',
  depVersions: {
  "productupdates-ui": "static-1.7414",
  "apollo-dlb": "static-3.41",
  "chatspot-client-types": "static-1.8595",
  "chatspot-core": "static-1.15692",
  "client-types": "static-1.373",
  "copilot-plugins": "static-1.6429",
  "copilot-toolkit": "static-1.6456",
  "csstype": "static-1.38",
  "cssUtils": "static-1.495",
  "data-fetching-client": "static-1.8425",
  "foundations-components-test-utils": "static-1.3493",
  "graphql": "static-1.58",
  "head-dlb": "static-1.4003",
  "hs-test-utils": "static-1.6808",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10308",
  "I18n": "static-7.1391",
  "jasmine-runner": "static-1.5215",
  "msw": "static-1.39",
  "quartz": "static-1.5562",
  "quartz-core": "static-1.4781",
  "react-dlb": "static-1.53",
  "react-router-dom": "static-5.26",
  "superstore": "static-1.3581",
  "ui-components-test-utils": "static-1.4447",
  "webpack-env": "static-1.54",
  "amplitude-session-replay-browser": "static-1.32",
  "apollo-stack-hubspot": "static-3.43",
  "enviro": "static-4.306",
  "feedback-loader": "static-1.26570",
  "foundations-assets": "static-1.3736",
  "foundations-components": "static-1.6008",
  "foundations-theming": "static-1.3129",
  "history": "static-4.47",
  "hub-http": "static-1.4807",
  "HubStyle": "static-2.10617",
  "icons": "static-2.592",
  "immer": "static-1.33",
  "moment": "static-3.26",
  "PortalIdParser": "static-2.284",
  "quick-fetch": "static-1.2772",
  "raven": "static-3.4766",
  "react": "static-7.151",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.15389",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.4327",
  "react-virtualized": "static-2.73",
  "redux": "static-4.16",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.3524",
  "sanitize": "static-1.3195",
  "sanitize-text": "static-1.6986",
  "styled-components": "static-2.64",
  "StyleGuideUI": "static-3.461",
  "transmute": "static-2.29",
  "ui-addon-avatars": "static-2.8156",
  "ui-addon-calendars": "static-2.4158",
  "ui-addon-draggable": "static-3.3685",
  "ui-addon-i18n": "static-1.9735",
  "ui-addon-opt": "static-4.7447",
  "ui-addon-react-router-dom": "static-1.8418",
  "ui-images": "static-2.835",
  "UIComponents": "static-3.7256",
  "usage-tracker": "static-1.6277",
  "usage-tracker-core": "static-1.6127",
  "usage-tracker-session-replay": "static-1.3963",
  "hs-promise-rejection-tracking": "static-1.4306",
  "raven-hubspot": "static-1.5073",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3063",
  "immutable": "static-2.19",
  "metrics-js": "static-1.8459",
  "bend-plugin-trellis-migration": "static-1.2456",
  "bend-plugin-quartz": "static-1.1839",
  "quartz-webpack": "static-1.1786",
  "ts-schema": "static-1.3138",
  "ai-components-ui-library": "static-1.5248",
  "ai-rendering-library": "static-1.5209",
  "foundations-theming-specialty": "static-1.846",
  "ui-brand-identity-lib": "static-1.8881",
  "sassPrefix": "static-1.131",
  "HeadJS": "static-2.577",
  "framer-motion": "static-1.40",
  "hs-test-utils-bend-plugin": "static-1.1919",
  "testing-library": "static-1.120",
  "i18n-data": "static-1.197",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.3150",
  "quartz-core-utils": "static-1.2429",
  "dispatcher": "static-1.112",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.648",
  "hub-http-shared-msw-handlers": "static-1.7076",
  "hubspotter-http": "static-1.3588",
  "hubspotter-http-shared-msw-handlers": "static-1.7074",
  "mobile-manifest-mixins": "static-1.348",
  "platform-navigation-bootstrap": "static-1.11220",
  "ui-fonts": "static-1.332",
  "hs-story-utils": "static-1.8203",
  "bend-plugin-foundations-components": "static-1.2276",
  "floating-ui": "static-1.28",
  "react-aria": "static-1.38",
  "tanstack-table": "static-1.23",
  "bend-plugin-foundations-theming": "static-1.1612",
  "foundations-theming-base": "static-1.2114",
  "autolinker": "static-3.11",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.46",
  "SharedI18nStrings": "static-1.162",
  "ContentUtils": "static-1.63347",
  "avatar-components": "static-1.1241",
  "customer-data-filters": "static-1.47830",
  "customer-data-filters-ui": "static-1.34015",
  "customer-data-objects": "static-1.6423",
  "customer-data-reference-ui-components": "static-1.11804",
  "ExportDialog": "static-6.9198",
  "highlight.js": "static-1.45",
  "markdown-it": "static-1.6",
  "react-table": "static-1.15",
  "reporting-action-components": "static-1.36418",
  "reporting-ui-components": "static-2.59124",
  "reporting-visualizations": "static-1.53923",
  "ui-addon-teams": "static-1.19791",
  "ui-addon-upgrades": "static-9.16050",
  "file-manager-components": "static-1.18701",
  "FileManagerLib": "static-1.34342",
  "react-colorpicker": "static-2.9056",
  "platform-infra-nav-components": "static-1.6695",
  "cms-field-types": "static-1.3597",
  "content-icons-ui": "static-1.1892",
  "underscore": "static-1.8",
  "atom": "static-1.4018",
  "customer-data-objects-ui-components": "static-1.11697",
  "customer-data-property-utils": "static-1.6736",
  "customer-data-ui-utilities": "static-1.8534",
  "deep-diff": "static-1.5",
  "FormUrlGenerator": "static-2.3533",
  "framework-builder-read-service-client": "static-1.3059",
  "framework-data-schema-quick-fetch": "static-1.5586",
  "framework-data-schema-resolvers": "static-1.5681",
  "inbound-db-meta-service-client": "static-1.2791",
  "inbound-db-properties-service-client": "static-1.2933",
  "lodash": "static-4.7",
  "PatternValidationJS": "static-1.437",
  "property-description-translator": "static-1.2661",
  "property-translator": "static-1.4200",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.6957",
  "reference-resolvers-lite": "static-1.6792",
  "crm-message-bus": "static-1.36903",
  "customer-data-filters-ui-msw-helpers": "static-1.16448",
  "content-assistance-lib": "static-1.6315",
  "dashboard-lib": "static-1.76000",
  "getting-started-shared-tasks": "static-1.12726",
  "hubspot-prosemirror": "static-1.13759",
  "integrations-lib": "static-1.10643",
  "prosemirror": "static-1.13",
  "reporting-data": "static-1.61846",
  "reporting-snowflake": "static-1.50467",
  "self-service-api": "static-1.9016",
  "share-with-third-party-component-lib": "static-1.7475",
  "ui-business-units-lib": "static-1.7686",
  "user-context": "static-1.3985",
  "frontend-preferences-client": "static-1.6680",
  "highcharts": "static-8.80",
  "reporting-plugins": "static-1.6945",
  "reporting-reports": "static-1.61530",
  "usage-tracker-container": "static-1.6267",
  "crm-object-map": "static-1.1981",
  "feature-store-service-types": "static-1.3493",
  "growth-monetization-service-types": "static-1.3500",
  "salesImages": "static-1.500",
  "upgrade-management-service-types": "static-1.3484",
  "media-bridge-lib": "static-1.16724",
  "video-data-lib": "static-1.29627",
  "FileManagerCore": "static-1.34201",
  "FileManagerImages": "static-1.31852",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.4339",
  "react-dnd-compat": "static-1.3466",
  "react-immutable-render-mixin": "static-1.9",
  "persist-promise": "static-1.2559",
  "batch-promise": "static-1.401",
  "crm-pipelines-api-client-types": "static-1.3130",
  "fast-json-stable-stringify": "static-1.4",
  "external-options-client-types": "static-1.3086",
  "react-transition-group": "static-1.7",
  "ui-addon-video-player": "static-1.7577",
  "ui-coaching-tips": "static-1.23027",
  "onboarding-scopes": "static-1.5366",
  "redux-actions": "static-3.7",
  "ui-asset-management-lib": "static-1.9080",
  "emoji-mart": "static-3.4",
  "growth-payments-core": "static-1.21210",
  "knowledge-content-types": "static-1.7739",
  "payment-link-components": "static-1.18797",
  "rich-text-lib": "static-1.17459",
  "ui-addon-emoji-picker": "static-1.8751",
  "ui-shepherd-react": "static-3.8872",
  "flux-actions": "static-1.273",
  "integrations-error-boundary-lib": "static-1.8058",
  "integrations-tracking-lib": "static-1.4320",
  "laboratory-lib": "static-3.6065",
  "native-integrations-shared-strings": "static-1.6648",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9282",
  "rxjs": "static-5.10",
  "reporting-client-types": "static-1.1916",
  "hubspot-apollo-client": "static-1.3635",
  "reporting-datasets-permissions-lib": "static-1.7741",
  "getting-started-shared-tasks-store": "static-1.11844",
  "campaign-roi-lib": "static-1.3193",
  "crm-index-visualization-object-layout": "static-1.669",
  "crm-links": "static-1.4915",
  "crm-object-search-query-utilities": "static-1.6344",
  "customer-data-properties": "static-1.45943",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7162",
  "audio-components": "static-1.4468",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.3358",
  "video-components": "static-1.7979",
  "video-embed": "static-1.30468",
  "growth-onboarding-feedback-components": "static-1.5260",
  "timezone-utils": "static-2.4055",
  "commerce-analytics-service-client": "static-1.2516",
  "commerce-tours-lib": "static-1.3601",
  "growth-onboarding-reliability": "static-1.3966",
  "onboarding-tours": "static-1.14339",
  "sales-checkout-service-client": "static-1.2528",
  "ui-addon-iframeable": "static-1.7703",
  "data-token-picker": "static-1.14124",
  "universal-page-editor-lib": "static-1.1751",
  "apollo-link-hub-http": "static-2.3590",
  "location-customization-utils-lib": "static-1.4136",
  "calling-cross-tab-library": "static-1.18021",
  "calling-lifecycle-messages": "static-1.51663",
  "commerce-products-lib": "static-1.5029",
  "conditional-properties-service-client": "static-1.2922",
  "google-libphonenumber": "static-1.11",
  "inbounddb-objects-service-types": "static-1.3215",
  "object-builder-ui-client": "static-1.42408",
  "pipeline-validation-client-types": "static-1.2877",
  "smart-property-lib": "static-1.868",
  "ui-addon-form-validation": "static-1.9833",
  "immerable": "static-1.2958",
  "social-insights-client-types": "static-1.17828",
  "outpost": "static-1.3168",
  "growth-data-modal": "static-1.4035",
  "onboarding-tours-client": "static-1.3309",
  "growth-onboarding-confetti": "static-1.1916",
  "navigation-components": "static-1.13877",
  "ui-shepherd-tracker": "static-1.6253",
  "ui-universal-auth": "static-1.7609",
  "magpie-lib": "static-1.4482",
  "navigation-messaging": "static-1.3204",
  "crm-record-cards-service-types": "static-1.2759",
  "calling-internal-common": "static-1.30041",
  "shared-worker-versioning": "static-1.9884",
  "calling-global-api": "static-1.57986",
  "calling-lifecycle-internal": "static-1.59368",
  "customer-data-tracking": "static-1.5614",
  "products-iframe-lib": "static-1.3228",
  "products-ui-components-shared-msw-handlers": "static-1.7461",
  "breeze-intelligence-kit": "static-1.4053",
  "fsm": "static-1.2516",
  "policy-lib": "static-1.5600",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.7222",
  "idb-keyval": "static-1.20",
  "magpie-types": "static-1.3942",
  "simple-logging-lib": "static-1.1846",
  "calling-error-reporting": "static-1.30047",
  "calling-usage-tracker": "static-1.5303",
  "calling-orchestration-shared-library": "static-1.30166",
  "conversations-skeleton-state": "static-1.6195",
  "multi-currency-client-types": "static-1.2775",
  "sales-views-client-types": "static-1.3126",
  "trellis-story-utils": "static-1.3359",
  "storybook-react": "static-1.3",
  "calling-orchestration-schema": "static-1.30391"
},
  depPathPrefixes: {
  "productupdates-ui": "/productupdates-ui/static-1.7414",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "chatspot-client-types": "/chatspot-client-types/static-1.8595",
  "chatspot-core": "/chatspot-core/static-1.15692",
  "client-types": "/client-types/static-1.373",
  "copilot-plugins": "/copilot-plugins/static-1.6429",
  "copilot-toolkit": "/copilot-toolkit/static-1.6456",
  "csstype": "/csstype/static-1.38",
  "cssUtils": "/cssUtils/static-1.495",
  "data-fetching-client": "/data-fetching-client/static-1.8425",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3493",
  "graphql": "/graphql/static-1.58",
  "head-dlb": "/head-dlb/static-1.4003",
  "hs-test-utils": "/hs-test-utils/static-1.6808",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10308",
  "I18n": "/I18n/static-7.1391",
  "jasmine-runner": "/jasmine-runner/static-1.5215",
  "msw": "/msw/static-1.39",
  "quartz": "/quartz/static-1.5562",
  "quartz-core": "/quartz-core/static-1.4781",
  "react-dlb": "/react-dlb/static-1.53",
  "react-router-dom": "/react-router-dom/static-5.26",
  "superstore": "/superstore/static-1.3581",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4447",
  "webpack-env": "/webpack-env/static-1.54",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.32",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "enviro": "/enviro/static-4.306",
  "feedback-loader": "/feedback-loader/static-1.26570",
  "foundations-assets": "/foundations-assets/static-1.3736",
  "foundations-components": "/foundations-components/static-1.6008",
  "foundations-theming": "/foundations-theming/static-1.3129",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.4807",
  "HubStyle": "/HubStyle/static-2.10617",
  "icons": "/icons/static-2.592",
  "immer": "/immer/static-1.33",
  "moment": "/moment/static-3.26",
  "PortalIdParser": "/PortalIdParser/static-2.284",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "raven": "/raven/static-3.4766",
  "react": "/react/static-7.151",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.15389",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.4327",
  "react-virtualized": "/react-virtualized/static-2.73",
  "redux": "/redux/static-4.16",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.3524",
  "sanitize": "/sanitize/static-1.3195",
  "sanitize-text": "/sanitize-text/static-1.6986",
  "styled-components": "/styled-components/static-2.64",
  "StyleGuideUI": "/StyleGuideUI/static-3.461",
  "transmute": "/transmute/static-2.29",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8156",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.4158",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.3685",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9735",
  "ui-addon-opt": "/ui-addon-opt/static-4.7447",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8418",
  "ui-images": "/ui-images/static-2.835",
  "UIComponents": "/UIComponents/static-3.7256",
  "usage-tracker": "/usage-tracker/static-1.6277",
  "usage-tracker-core": "/usage-tracker-core/static-1.6127",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.3963",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4306",
  "raven-hubspot": "/raven-hubspot/static-1.5073",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.8459",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2456",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1839",
  "quartz-webpack": "/quartz-webpack/static-1.1786",
  "ts-schema": "/ts-schema/static-1.3138",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5248",
  "ai-rendering-library": "/ai-rendering-library/static-1.5209",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.846",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.8881",
  "sassPrefix": "/sassPrefix/static-1.131",
  "HeadJS": "/HeadJS/static-2.577",
  "framer-motion": "/framer-motion/static-1.40",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1919",
  "testing-library": "/testing-library/static-1.120",
  "i18n-data": "/i18n-data/static-1.197",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.3150",
  "quartz-core-utils": "/quartz-core-utils/static-1.2429",
  "dispatcher": "/dispatcher/static-1.112",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.648",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7076",
  "hubspotter-http": "/hubspotter-http/static-1.3588",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7074",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11220",
  "ui-fonts": "/ui-fonts/static-1.332",
  "hs-story-utils": "/hs-story-utils/static-1.8203",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2276",
  "floating-ui": "/floating-ui/static-1.28",
  "react-aria": "/react-aria/static-1.38",
  "tanstack-table": "/tanstack-table/static-1.23",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1612",
  "foundations-theming-base": "/foundations-theming-base/static-1.2114",
  "autolinker": "/autolinker/static-3.11",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.46",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "ContentUtils": "/ContentUtils/static-1.63347",
  "avatar-components": "/avatar-components/static-1.1241",
  "customer-data-filters": "/customer-data-filters/static-1.47830",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.34015",
  "customer-data-objects": "/customer-data-objects/static-1.6423",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11804",
  "ExportDialog": "/ExportDialog/static-6.9198",
  "highlight.js": "/highlight.js/static-1.45",
  "markdown-it": "/markdown-it/static-1.6",
  "react-table": "/react-table/static-1.15",
  "reporting-action-components": "/reporting-action-components/static-1.36418",
  "reporting-ui-components": "/reporting-ui-components/static-2.59124",
  "reporting-visualizations": "/reporting-visualizations/static-1.53923",
  "ui-addon-teams": "/ui-addon-teams/static-1.19791",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16050",
  "file-manager-components": "/file-manager-components/static-1.18701",
  "FileManagerLib": "/FileManagerLib/static-1.34342",
  "react-colorpicker": "/react-colorpicker/static-2.9056",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6695",
  "cms-field-types": "/cms-field-types/static-1.3597",
  "content-icons-ui": "/content-icons-ui/static-1.1892",
  "underscore": "/underscore/static-1.8",
  "atom": "/atom/static-1.4018",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11697",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6736",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8534",
  "deep-diff": "/deep-diff/static-1.5",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3533",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3059",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5586",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5681",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2791",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2933",
  "lodash": "/lodash/static-4.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "property-description-translator": "/property-description-translator/static-1.2661",
  "property-translator": "/property-translator/static-1.4200",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.6957",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6792",
  "crm-message-bus": "/crm-message-bus/static-1.36903",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.16448",
  "content-assistance-lib": "/content-assistance-lib/static-1.6315",
  "dashboard-lib": "/dashboard-lib/static-1.76000",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12726",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13759",
  "integrations-lib": "/integrations-lib/static-1.10643",
  "prosemirror": "/prosemirror/static-1.13",
  "reporting-data": "/reporting-data/static-1.61846",
  "reporting-snowflake": "/reporting-snowflake/static-1.50467",
  "self-service-api": "/self-service-api/static-1.9016",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7475",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7686",
  "user-context": "/user-context/static-1.3985",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6680",
  "highcharts": "/highcharts/static-8.80",
  "reporting-plugins": "/reporting-plugins/static-1.6945",
  "reporting-reports": "/reporting-reports/static-1.61530",
  "usage-tracker-container": "/usage-tracker-container/static-1.6267",
  "crm-object-map": "/crm-object-map/static-1.1981",
  "feature-store-service-types": "/feature-store-service-types/static-1.3493",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3500",
  "salesImages": "/salesImages/static-1.500",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3484",
  "media-bridge-lib": "/media-bridge-lib/static-1.16724",
  "video-data-lib": "/video-data-lib/static-1.29627",
  "FileManagerCore": "/FileManagerCore/static-1.34201",
  "FileManagerImages": "/FileManagerImages/static-1.31852",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.4339",
  "react-dnd-compat": "/react-dnd-compat/static-1.3466",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "persist-promise": "/persist-promise/static-1.2559",
  "batch-promise": "/batch-promise/static-1.401",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3130",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "external-options-client-types": "/external-options-client-types/static-1.3086",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7577",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.23027",
  "onboarding-scopes": "/onboarding-scopes/static-1.5366",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.9080",
  "emoji-mart": "/emoji-mart/static-3.4",
  "growth-payments-core": "/growth-payments-core/static-1.21210",
  "knowledge-content-types": "/knowledge-content-types/static-1.7739",
  "payment-link-components": "/payment-link-components/static-1.18797",
  "rich-text-lib": "/rich-text-lib/static-1.17459",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8751",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8872",
  "flux-actions": "/flux-actions/static-1.273",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.8058",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4320",
  "laboratory-lib": "/laboratory-lib/static-3.6065",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6648",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9282",
  "rxjs": "/rxjs/static-5.10",
  "reporting-client-types": "/reporting-client-types/static-1.1916",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3635",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.7741",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11844",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.3193",
  "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.669",
  "crm-links": "/crm-links/static-1.4915",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6344",
  "customer-data-properties": "/customer-data-properties/static-1.45943",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7162",
  "audio-components": "/audio-components/static-1.4468",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.3358",
  "video-components": "/video-components/static-1.7979",
  "video-embed": "/video-embed/static-1.30468",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5260",
  "timezone-utils": "/timezone-utils/static-2.4055",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2516",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3601",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3966",
  "onboarding-tours": "/onboarding-tours/static-1.14339",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2528",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7703",
  "data-token-picker": "/data-token-picker/static-1.14124",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1751",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3590",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.4136",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18021",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.51663",
  "commerce-products-lib": "/commerce-products-lib/static-1.5029",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2922",
  "google-libphonenumber": "/google-libphonenumber/static-1.11",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3215",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.42408",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2877",
  "smart-property-lib": "/smart-property-lib/static-1.868",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9833",
  "immerable": "/immerable/static-1.2958",
  "social-insights-client-types": "/social-insights-client-types/static-1.17828",
  "outpost": "/outpost/static-1.3168",
  "growth-data-modal": "/growth-data-modal/static-1.4035",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3309",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1916",
  "navigation-components": "/navigation-components/static-1.13877",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6253",
  "ui-universal-auth": "/ui-universal-auth/static-1.7609",
  "magpie-lib": "/magpie-lib/static-1.4482",
  "navigation-messaging": "/navigation-messaging/static-1.3204",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2759",
  "calling-internal-common": "/calling-internal-common/static-1.30041",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9884",
  "calling-global-api": "/calling-global-api/static-1.57986",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.59368",
  "customer-data-tracking": "/customer-data-tracking/static-1.5614",
  "products-iframe-lib": "/products-iframe-lib/static-1.3228",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7461",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4053",
  "fsm": "/fsm/static-1.2516",
  "policy-lib": "/policy-lib/static-1.5600",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7222",
  "idb-keyval": "/idb-keyval/static-1.20",
  "magpie-types": "/magpie-types/static-1.3942",
  "simple-logging-lib": "/simple-logging-lib/static-1.1846",
  "calling-error-reporting": "/calling-error-reporting/static-1.30047",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5303",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.30166",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6195",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2775",
  "sales-views-client-types": "/sales-views-client-types/static-1.3126",
  "trellis-story-utils": "/trellis-story-utils/static-1.3359",
  "storybook-react": "/storybook-react/static-1.3",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.30391"
}
};
